import OperationLogList from '@/pages/components/manage/sys/operation-log/OperationLogList';

export default {
    list: OperationLogList,
};
